/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import Loader from 'views/Shared/components/Loader';
import AdminPanel from './AdminPanel';
import ProfilePanel from './ProfilePanel';
import '../styles/profilepage.scss';

const getCustomPaddingStyle = showEditUserFields => (showEditUserFields ? '0.4rem' : '');

const getFirstName = (showEditUserFields, isInValidFirstName, userData) => (!showEditUserFields && (isInValidFirstName ? 'NA' : userData.firstName));

const getLastName = (showEditUserFields, isInValidLastName, userData) => (!showEditUserFields && (isInValidLastName ? 'NA' : userData.lastName));

const getPhoneNumber = (showEditUserFields, isInvalidPhoneNumber, userData) => (
    !showEditUserFields && (isInvalidPhoneNumber ? 'NA' : userData.phone)
);

// ✅ FIX: Use optional chaining and fallback to direct tenantId
const getSelectedTenant = (userDetails, currentTenantId) => {
    if (!userDetails?.userTenants || !currentTenantId) return null;
    return userDetails.userTenants.find(ut => {
        const tid = ut?.UserTenantRole?.tenantId || ut?.tenantId;
        return tid === currentTenantId;
    }) || null;
};

const getJobTitle = (showEditUserFields, isInvalidJobTitle, userData, currentTenantId) => {
    const selectedTenant = getSelectedTenant(userData, currentTenantId);
    // ✅ FIX: Safe access to jobTitle
    const job = selectedTenant?.UserTenantRole?.jobTitle || '';
    return !showEditUserFields && (isInvalidJobTitle ? 'NA' : job);
};

const ProfilePage = ({
    userData, loading, columns, visible, setVisible, getApiKey, showApiKeyAlert,
    setShowApiKeyAlert, apiKeyResult, createAPIKeyLoading, domains, refetchUserInfo,
    showEditUserFields, firstName, setFirstName, lastName, setLastName, phone, setPhone,
    jobTitle, setJobTitle, onClickEditUserInfo, onSaveUserInfo, editUserLoading,
    updateUserLoading, setShowEditUserFields, selectedUser, setSelectedUser,
    copyApiKey, isApiKeyCopied, showApiKey, setShowApiKey, users, currentActiveTenantId,
}) => {
    const isInValidFirstName = userData?.firstName === null || userData?.firstName === undefined || userData?.firstName === '';
    const isInvalidLastName = userData?.lastName === null || userData?.lastName === undefined || userData?.lastName === '';
    const isInvalidPhoneNumber = userData?.phone === null || userData?.phone === '' || userData?.phone === undefined;
    const selectedTenant = getSelectedTenant(userData, currentActiveTenantId);
    const isInvalidJobTitle = !selectedTenant?.UserTenantRole?.jobTitle;
    // ✅ FIX: Safe access to iamTenant.tenantId
    const isCurrentTenant = userData?.iamTenant?.tenantId === currentActiveTenantId;

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="true-comply-create-user-profile">
            <h5>My Profile</h5>
            <ProfilePanel
                showEditUserFields={showEditUserFields}
                firstName={firstName}
                setFirstName={setFirstName}
                lastName={lastName}
                setLastName={setLastName}
                phone={phone}
                setPhone={setPhone}
                jobTitle={jobTitle}
                setJobTitle={setJobTitle}
                onClickEditUserInfo={onClickEditUserInfo}
                onSaveUserInfo={onSaveUserInfo}
                editUserLoading={editUserLoading}
                updateUserLoading={updateUserLoading}
                setShowEditUserFields={setShowEditUserFields}
                loading={loading}
                userData={userData}
                getCustomPaddingStyle={getCustomPaddingStyle}
                getFirstName={getFirstName}
                getLastName={getLastName}
                getPhoneNumber={getPhoneNumber}
                getJobTitle={getJobTitle}
                isInValidFirstName={isInValidFirstName}
                isInvalidLastName={isInvalidLastName}
                isInvalidPhoneNumber={isInvalidPhoneNumber}
                isInvalidJobTitle={isInvalidJobTitle}
                currentActiveTenantId={currentActiveTenantId}
            />
            {/* ✅ FIX: Safe access to iamTenant.tenantId */}
            {(userData?.iamRole === 'ADMIN' && isCurrentTenant)
                && (
                    <AdminPanel
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                        users={users}
                        getApiKey={getApiKey}
                        createAPIKeyLoading={createAPIKeyLoading}
                        showApiKeyAlert={showApiKeyAlert}
                        setShowApiKeyAlert={setShowApiKeyAlert}
                        showApiKey={showApiKey}
                        apiKeyResult={apiKeyResult}
                        isApiKeyCopied={isApiKeyCopied}
                        copyApiKey={copyApiKey}
                        setShowApiKey={setShowApiKey}
                        visible={visible}
                        setVisible={setVisible}
                        refetchUserInfo={refetchUserInfo}
                        domains={domains}
                        columns={columns}
                        // ✅ FIX: Safe access
                        tenantId={userData?.iamTenant?.tenantId}
                    />
                )}
        </div>
    );
};

export default ProfilePage;